export default __webpack_public_path__ + "static/media/cws_final_logo.ae343efc.png";